// The public acknowledgment contract contains names only, never contact fields or records.
function safeContributorNames(contributors) {
  if (!Array.isArray(contributors)) return [];
  return contributors
    .filter(name => typeof name === 'string' && name.indexOf('@') === -1)
    .map(name => name.trim())
    .filter(Boolean);
}

module.exports = { safeContributorNames };
